import React from "react";
import { clientConfigFn } from 'clientConfig';

const FooterText = () => {
    const {footerText} = clientConfigFn();
        return (
                <div>
                    {footerText === "" ?
                        <></>
                        : <div>
                                {footerText}
                        </div>
                    }
                </div>
        )
};

export {
    FooterText
};

